export default function Marquee({ items, dark = true }) {
  const Row = () => (
    <div className="flex shrink-0 items-center">
      {items.map((item, i) => (
        <span key={i} className="flex items-center">
          <span
            className={`whitespace-nowrap font-mono text-sm font-medium uppercase tracking-[0.3em] ${
              dark ? "text-slate-500" : "text-slate-400"
            }`}
          >
            {item}
          </span>
          <span className={`mx-8 inline-block h-1.5 w-1.5 rotate-45 ${dark ? "bg-cyan-500/70" : "bg-cyan-600/60"}`} />
        </span>
      ))}
    </div>
  );

  return (
    <div
      data-testid="editorial-marquee"
      className={`relative overflow-hidden border-y py-5 ${
        dark ? "border-slate-800/80 bg-navy-950" : "border-slate-200 bg-slate-50"
      }`}
    >
      <div className="flex w-max animate-marquee">
        <Row />
        <Row />
      </div>
    </div>
  );
}
